import { Box, Text } from "theme-ui";

import Modal from "../Modal";
import * as styles from "./ModalDetails.styles";

export default function ModalDetails({
  appLogo,
  title,
  subTitle,
  onClose,
  closeButtonLabel,
  content,
  image,
}) {
  return (
    <Modal
      appLogo={appLogo}
      title={title}
      subTitle={subTitle}
      onClose={onClose}
      closeButtonLabel={closeButtonLabel}
    >
      {image?.url && (
        <Box sx={styles.imageContainer}>
          <Box
            as="img"
            src={image.url}
            alt={image?.alt}
            sx={styles.modalImage}
          />
        </Box>
      )}

      {content && (
        <Box sx={styles.contentContainer}>
          <Text variant="copy3Light">{content}</Text>
        </Box>
      )}
    </Modal>
  );
}
